import { render, staticRenderFns } from "./textEdit.vue?vue&type=template&id=667f9648&scoped=true&"
import script from "./textEdit.vue?vue&type=script&lang=js&"
export * from "./textEdit.vue?vue&type=script&lang=js&"
import style0 from "./textEdit.vue?vue&type=style&index=0&id=667f9648&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667f9648",
  null
  
)

export default component.exports